import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { StyledBarContainer } from './app-usage-chart.style'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
    },
};

const labels = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb'];

export const data = {
    labels,
    datasets: [
        {
            data: [0.4, 1.1, 0.8, 1.5, 2.7],
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
    ],
};

const AdminUsageChart = () => {
    return (
        <StyledBarContainer style={{ marginTop: "3.2rem" }}>
            <div className="container-top">
                <h3>Usage Analytics</h3>
            </div>
            <div
                style={{ padding: "2rem 1.9rem 1.7rem 2.4rem" }}
            >
                <Line options={options} data={data} />
            </div>
        </StyledBarContainer>
    )
}

export { AdminUsageChart }